var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout--default"},[_c('Nav'),_vm._v(" "),_c('div',{staticClass:"site-content site-content--application"},[_c('Messages'),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }